import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AdmihairBaseComponent } from '../../../admihair-base.component';
import { LazyLoadEvent, SelectItem } from 'primeng/api';
import { Paginador } from 'src/app/admihair/api/dto/paginacao/paginador';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Table } from 'primeng/table';
import { ClienteRetornoService } from 'src/app/admihair/service/cliente-retorno.service';
import { ClienteRetorno } from 'src/app/admihair/api/dto/cliente-retorno';
import { Empresa } from 'src/app/admihair/api/dto/empresa';

@Component({
  selector: 'app-central-cliente-retorno',
  templateUrl: './central-cliente-retorno.component.html',
  styleUrls: ['./central-cliente-retorno.component.scss']
})
export class CentralClienteRetornoComponent extends AdmihairBaseComponent implements OnInit {

  @ViewChild('filter') filter!: ElementRef;
  empresaSelecionada?: Empresa;
  loadingTable: boolean = false;
  retornosClientes: ClienteRetorno[] = [];
  itensPaginados?: Paginador<ClienteRetorno>;
  numeroPagina: number = 0;
  inputBusca?: string = '';
  ordenacao: string = 'dataRetorno,ASC';
  tamanhoPagina: number = 10;

  dataFiltroInicio?: Date;
  dataFiltroFinal?: Date;

  tipoMensagem?: string;
  exibirDialogRetorno: boolean = false;
  headerDialogRetorno: string = '';
  conteudoMensagem: string = '';
  retornoSelecionado?: ClienteRetorno;

  exibirDialogSemContato: boolean = false;
  textoDialogSemContato?: string;

  constructor(private clienteRetornoService: ClienteRetornoService,
    erroService: ErroService,
    storageService: UtilStorageService,
    router: Router,
    activatedRoute: ActivatedRoute) { super(erroService, storageService, router, activatedRoute) }

  ngOnInit(): void {
    this.empresaSelecionada = this.getEmpresa();
  }

  filtrar() {
    if (this.dataFiltroInicio && this.dataFiltroFinal) {
      this.listarRetornosClientes();
    }
  }


  listarRetornosClientes() {
    this.loadingTable = true;
    this.clienteRetornoService.listarRetornosPorEmpresaPaginado(this.getEmpresa().id,
      this.numeroPagina, this.tamanhoPagina, this.ordenacao, this.inputBusca, this.dataFiltroInicio, this.dataFiltroFinal).subscribe({
        next: (data: Paginador<ClienteRetorno>) => {
          this.itensPaginados = data;
          this.retornosClientes = data.content;
          this.loadingTable = false;
        },
        error: (err: any) => {
          this.loadingTable = false;
          this.exibirMensagemErro(err)
        }
      });
  }

  onLazyLoad(event: LazyLoadEvent) {
    if (event.first !== undefined && event.rows !== undefined) {
      if (event.first === 0 && event.rows === 0) {
        this.numeroPagina = 0;
      } else {
        this.numeroPagina = event.first / event.rows;
      }
    }
    this.definirOrdenacao(event.sortField, event.sortOrder);
    this.loadingTable = true;
    this.listarRetornosClientes();
  }

  definirOrdenacao(sortField?: string, sortOrder?: number) {
    const campoDeOrdenacao = sortField ? sortField : 'dataRetorno';
    const direcaoOrdenacao = sortOrder === -1 ? 'DESC' : 'ASC';
    this.ordenacao = `${campoDeOrdenacao},${direcaoOrdenacao}`;
  }

  buscar(event: Event) {
    this.inputBusca = (event.target as HTMLInputElement).value;
    this.listarRetornosClientes();
  }

  limpar(table: Table) {
    this.filter.nativeElement.value = '';
    this.inputBusca = '';
    this.limparFiltrosData();
    table.clear()
  }

  limparFiltrosData() {
    this.dataFiltroInicio = undefined;
    this.dataFiltroFinal = undefined;
  }

  abrirDialogRetorno(itemRetorno: ClienteRetorno, tipo: string) {
    if(!itemRetorno.contato && tipo === 'WHATSAPP') {
      this.textoDialogSemContato = 'contato principal';
      this.exibirDialogSemContato = true;
    
    } else if (!itemRetorno.email && tipo === 'EMAIL') {
      this.textoDialogSemContato = 'e-mail';
      this.exibirDialogSemContato = true;
      
    } else {
      
      if (tipo === 'WHATSAPP') {
        this.tipoMensagem = '1';
        this.headerDialogRetorno = 'Contato via WhatsApp';
        this.retornoSelecionado = itemRetorno;
        this.prepararConteudoMensagem();
  
      } else {
        this.tipoMensagem = '2';
        this.headerDialogRetorno = 'Contato via E-mail';
        this.retornoSelecionado = itemRetorno;
        this.prepararConteudoMensagem();
      }
  
      this.exibirDialogRetorno = true;
    }
  }

  prepararConteudoMensagem() {
    const nomeCliente = this.retornoSelecionado?.apelido;
    const tratamento = this.obterTratamentoPorHora();
    const nomeEmpresa = this.empresaSelecionada?.nomeFantasia;
    const descricaoItem = this.retornoSelecionado?.descricaoItem;
    const dataRetorno = this.retornoSelecionado?.dataRetorno;
    const codigoPlanoConta = this.retornoSelecionado?.codigoPlanoConta;
    const isPacote = this.retornoSelecionado?.pacote;

    let dataRetornoFormatada = '';
    if(dataRetorno) {
      const data = new Date(dataRetorno + 'T05:00:00Z');
      dataRetornoFormatada = data.toLocaleDateString();
    }

    let mensagem = '';

    if (codigoPlanoConta === 3) {
      mensagem = `Olá ${nomeCliente}, ${tratamento}. Tudo bem com você? Somos do ${nomeEmpresa}. ` +
               `Observamos aqui que seu produto ${descricaoItem} deve estar terminando e que se desejar, ` +
               `você já pode solicitar um outro. Ok?`;
    } else if (codigoPlanoConta === 4 && isPacote) {
      mensagem = `Olá ${nomeCliente}, ${tratamento}. Tudo bem com você? Somos do ${nomeEmpresa} ` +
               `e queremos comunicar que a partir de ${dataRetornoFormatada} você já pode agendar seu retorno ` +
               `para a utilização do seu ${descricaoItem}. Ok?`;
    } else if (codigoPlanoConta === 4) {
      mensagem = `Olá ${nomeCliente}, ${tratamento}. Tudo bem com você? Somos do ${nomeEmpresa} ` +
               `e queremos comunicar que a partir de ${dataRetornoFormatada} você já pode agendar seu retorno ` +
               `para a manutenção do serviço de ${descricaoItem}. Ok?`;
    }

    this.conteudoMensagem = mensagem;
  }

  enviarMensagem() {
    if(this.tipoMensagem === '1') {
      this.enviarMensagemWhatsApp();
    } else {
      this.enviarMensagemEmail();
    }
  }

  enviarMensagemWhatsApp() {
    
    if(this.retornoSelecionado?.contato) {
      const numeroLimpo = this.retornoSelecionado.contato.replace(/\D/g, '');
      const url = `https://api.whatsapp.com/send?l=pt_br&phone=+55${numeroLimpo}` +
      `&text=${this.conteudoMensagem}`;

      window.open(url, '_blank');
    }

  }

  enviarMensagemEmail() {

  }


  fecharDialogRetorno() {
    this.retornoSelecionado = undefined;
  }

  obterTratamentoPorHora(): string {
    const horaAtual = new Date().getHours();

    if (horaAtual >= 5 && horaAtual < 12) {
      return 'bom dia';
    } else if (horaAtual >= 12 && horaAtual < 18) {
      return 'boa tarde';
    } else {
      return 'boa noite';
    }
  }
}
